import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FindDetailWishListService {
  private state: string = '';
  private district: string = '';
  private wishlistId: any = '';

  setVariables(state: string, district: string, wishlistId?: any) {
    this.state = state;
    this.district = district;
    this.wishlistId = wishlistId
  }

  getVariables() {
    return { state: this.state, district: this.district, wishlistId: this.wishlistId };
  }
}
